import { Icon, Button, BUTTON_SIZE } from '@sanlam-glacier/app-common/components';
import { useNavigate } from 'react-router-dom';
import { generateNewProposalPath } from 'routes/route-paths';
import './proposal.styles.scss';
import { Theme } from 'components/atoms/theme/Theme';

type CreateNewProposalButtonProps = {
  alignEnd?: boolean;
};
export const CreateNewProposalButton = ({ alignEnd = false }: CreateNewProposalButtonProps) => {
  const navigate = useNavigate();

  const navigateToNewProposal = () => navigate(generateNewProposalPath());

  return (
    <Theme variant='secondary'>
      <Button
        className={`create-new-proposal-button ${alignEnd ? 'align-end' : ''}`}
        size={BUTTON_SIZE.SMALL}
        onClick={() => {
          navigateToNewProposal();
        }}
        startIcon={<Icon icon='content_add' />}
      >
        Create new proposal
      </Button>
    </Theme>
  );
};
